"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IE_ACCOUNT_NUMBER = exports.IE_SORT_CODE = exports.IE_PPS = exports.IE_EIRCODE = exports.IE_PHONE_NUMBER = exports.GB_ACCOUNT_NUMBER = exports.GB_SORT_CODE = exports.GB_NI = exports.GB_POSTCODE = exports.GB_PHONE_NUMBER = void 0;
exports.GB_PHONE_NUMBER = /^\+?[0-9]{10,12}$/;
exports.GB_POSTCODE = /^([A-Z][A-HJ-Y]?[0-9][A-Z0-9]?) ?([0-9][A-Z]{2}|[G][I][R] ?0[Aa]{2})$/;
exports.GB_NI = /^[A-CEGHJ-PR-TW-Z]{1}[A-CEGHJ-NPR-TW-Z]{1}[0-9]{6}[A-DFM]{1}$/;
exports.GB_SORT_CODE = /^(?!(?:0{6}|00-00-00))(?:\d{6}|\d\d-\d\d-\d\d)$/;
exports.GB_ACCOUNT_NUMBER = /^\d{8}$/;
exports.IE_PHONE_NUMBER = /^[0-9]{7,10}$/;
exports.IE_EIRCODE = /([AC-FHKNPRTV-Y]\d{2}|D6W) ?([0-9AC-FHKNPRTV-Y]{4})$/;
exports.IE_PPS = /^[0-9]{7}[A-Z]?\/?[A-Z]?$/;
exports.IE_SORT_CODE = /^(?!(?:0{6}|00-00-00))(?:\d{6}|\d\d-\d\d-\d\d)$/;
exports.IE_ACCOUNT_NUMBER = /^\d{7,8}$/;
